import React, { useState } from "react";
import {
  CreateStarForFavoriteFalse,
  CreateStarForFavoriteTrue,
} from "./FavoriteStar";
import ToolTip from "../../../common/ToolTip/ToolTip";
import DepsUnitsModal from "../../../common/Modal/DepsUnitsModal";
import useConfiguration from "../../../../hooks/useConfiguration";
import ReactStars from "react-rating-stars-component";
import useSessionStorage from "../../../../hooks/useSessionStorage";
import { mapDepartmentsToCandidate } from "../../../common/Modal/action";
import { getCandidateLocationStatus, updateCandidateFavorites } from "./action";
import { useDispatch } from "react-redux";
import Mentor from "../../../assets/svg/Mentor";
const CandidateRating = ({ ratingValue }) => {
  let color = "";
  const val = ratingValue;
  if (val > 3) {
    color = "green";
  } else if (val > 2 && val <= 3) {
    color = "yellow";
  } else if (val > 0 && val <= 2) {
    color = "red ";
  } else if (val <= 0) {
    color = "black ";
  }
  const star = {
    size: 15,
    count: 5,
    value: ratingValue,
    edit: false,
    color: color,
    activeColor: color,
    a11y: true,
    isHalf: true,
    emptyIcon: <i className="fa fa-star-o" />,
    halfIcon: <i style={{ color: color }} className="fa fa-star-half-o" />,
    filledIcon: <i className="fa fa-star" />,
  };
  return <ReactStars {...star} />;
};
const StatusTable = ({
  tableData,
  userData,
  updateTableData,
  candidateRating,
}) => {
  const dispatch = useDispatch();
  const config = useConfiguration();
  const storage = useSessionStorage();
  const login = storage.getItem("login");
  const [showDepartmentModal, setShowDepartmentModal] = useState({
    status: false,
    element: {},
    page: "candidatesearchview",
  });
  const [currentDepStatusId, setCurrentDepStatusId] = useState(0);
  console.log({ tableData, showDepartmentModal, userData });
  const editChangeHandler = (element) => {
    setShowDepartmentModal((prev) => ({
      ...prev,
      status: true,
      element: {
        ...element,
        firstName: userData?.firstName,
        lastName: userData?.lastName,
        candidateUniqueId: userData?.candidateUniqueId,
      },
    }));
    setCurrentDepStatusId(element?.statusValue);
  };
  const updateStatusOfEmployer = () => {};
  const updateEmpDepStatus = ({ mappedParams }) => {
    dispatch(
      mapDepartmentsToCandidate({ baseURL: config.baseUrl, mappedParams })
    ).then((response) => {
      if (response) {
        const params = {
          employerUniqueId: login.employerUniqueId,
          candidateUniqueId: showDepartmentModal?.element?.candidateUniqueId,
        };
        dispatch(
          getCandidateLocationStatus({
            url: `${config.baseUrl}/Candidates/get-employers-location-candidate-status-list`,
            params,
          })
        );
      }
    });
  };
  const updateFavHandler = (locationId, isFavorite) => {
    const requestBody = {
      candidateUniqueIds: [userData.candidateUniqueId],
      employerUniqueId: login.employerUniqueId,
      appUserUniqueId: login.appUserUniqueId,
      locationId: locationId,
      isFavorite: isFavorite,
    };
    dispatch(
      updateCandidateFavorites({
        url: `${config.baseUrl}/Employers/set-candidate-favorite-status`,
        params: requestBody,
      })
    ).then(() => {
        const params = {
            employerUniqueId: login.employerUniqueId,
            candidateUniqueId: userData?.candidateUniqueId,
          };
          dispatch(
            getCandidateLocationStatus({
              url: `${config.baseUrl}/Candidates/get-employers-location-candidate-status-list`,
              params,
            })
          );
    });
  };


  const updateMentorHandler = (locationId, isFavorite) => {
    const requestBody = {
      candidateUniqueIds: [userData.candidateUniqueId],
      employerUniqueId: login.employerUniqueId,
      appUserUniqueId: login.appUserUniqueId,
      locationId: locationId,
      isMentor: isFavorite,
    };
    dispatch(
      updateCandidateFavorites({
        url: `${config.baseUrl}/Employers/set-candidate-mentor-status`,
        params: requestBody,
      })
    ).then(() => {
        const params = {
            employerUniqueId: login.employerUniqueId,
            candidateUniqueId: userData?.candidateUniqueId,
          };
          dispatch(
            getCandidateLocationStatus({
              url: `${config.baseUrl}/Candidates/get-employers-location-candidate-status-list`,
              params,
            })
          );
    });
  };



  const createStar = (count) => {
    let color = "";
    const val = count;
    if (val > 3) {
      color = "green";
    } else if (val > 2 && val <= 3) {
      color = "yellow";
    } else if (val > 0 && val <= 2) {
      color = "red ";
    } else if (val <= 0) {
      color = "black ";
    }
    const star = {
      size: 15,
      count: 5,
      value: count,
      edit: false,
      color: color,
      activeColor: color,
      a11y: true,
      isHalf: true,
      emptyIcon: <i className="fa fa-star-o" />,
      halfIcon: <i style={{ color: color }} className="fa fa-star-half-o" />,
      filledIcon: <i className="fa fa-star" />,
    };
    return <ReactStars {...star} />;
  };

  return (
    <>
      {showDepartmentModal?.status && (
        <DepsUnitsModal
          state={showDepartmentModal}
          updateState={setShowDepartmentModal}
          updateTableData={updateTableData}
          currentStatusId={currentDepStatusId}
          updateStatusOfEmployer={updateStatusOfEmployer}
          updateEmpDepStatus={updateEmpDepStatus}
        />
      )}
      <div className="row pt-4">
        <div className=" divscroll border-0">
          <div className="card-header border-bottom-0">
            <div>
              <div className="PrintHeader">
                <h4 className="mb-0">Location Status</h4>
              </div>
            </div>
            <div className="card-options">
              <span
                className="card-options-collapse"
                data-bs-toggle="card-collapse"
              >
                <i
                  className="fe fe-chevron-up"
                  style={{ cursor: "pointer" }}
                ></i>
              </span>
            </div>
          </div>
          <div className=" table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>Location Name</th>
                  <th>Status</th>
                  <th>Departments</th>
                  <th>Actions</th>
                  <th>Add/Remove Favorite</th>
                  <th><CreateStarForFavoriteFalse /></th>
                  <th>Add/Remove Mentor</th>
                  <th><Mentor fillColor={'white'}/> </th>
                  <th>Ratings</th>
                  <th>Last Rating Date</th>
                </tr>
              </thead>
              <tbody className="">
                {tableData &&
                  tableData.map((element, id) => (
                    <tr key={`${id}`}>
                      <td>{element.locationName}</td>
                      <td>{element.status}</td>
                      <td>
                        {element?.departments?.map((item) => (
                          <p>{item}</p>
                        ))}
                      </td>
                      <td>
                        {+element?.statusValue === 4 ||
                        +element?.statusValue === 5 ? (
                          <div className="">
                            <ToolTip
                              position={"left"}
                              value={"Edit Departments"}
                            >
                              <i
                                className="fa fa-edit fa-lg mt-1"
                                style={{ cursor: "pointer" }}
                                onClick={() => editChangeHandler(element)}
                              ></i>
                            </ToolTip>
                          </div>
                        ) : (
                          ""
                        )}
                      </td>


                      {element?.isFavorite ? (
                        <>
                          <td>
                            <button
                            style={{width:"100%",maxWidth:"10rem",minWidth:"fit-content"}}
                            disabled={!(+element?.statusValue === 4 ||
                              +element?.statusValue === 5 )}
                            onClick={() => updateFavHandler(element?.locationId,false)}
                              className="btn btn-primary"
                              type="button"
                            >
                              Remove Favorite
                            </button>
                          </td>
                          <td>
                            <CreateStarForFavoriteTrue />
                          </td>
                        </>
                      ) : !element?.isFavorite ? (
                        <>
                          <td>
                            <button
                            style={{width:"100%", maxWidth:"10rem",minWidth:"fit-content"}}
                            disabled={!(+element?.statusValue === 4 ||
                              +element?.statusValue === 5 )}
                            onClick={() => updateFavHandler(element?.locationId,true)}
                              className="btn btn-primary"
                              type="button"
                            >
                              Add Favorite
                            </button>
                          </td>
                          
                          <td>
                            <CreateStarForFavoriteFalse />
                          </td>
                        </>
                      ) : null}



                      {element?.isMentor ? (
                        <>
                          <td>
                            <button
                            style={{width:"100%",maxWidth:"10rem",minWidth:"fit-content"}}
                            disabled={!(+element?.statusValue === 4 ||
                              +element?.statusValue === 5 )}
                            onClick={() => updateMentorHandler(element?.locationId,false)}
                              className="btn btn-primary"
                              type="button"
                            >
                              Remove Mentor
                            </button>
                          </td>
                          <td>
                          <Mentor fillColor={'green'}/>
                          </td>
                        </>
                      ) : !element?.isMentor ? (
                        <>
                          <td>
                            <button
                            style={{width:"100%", maxWidth:"10rem",minWidth:"fit-content"}}
                            disabled={!(+element?.statusValue === 4 ||
                              +element?.statusValue === 5 )}
                            onClick={() => updateMentorHandler(element?.locationId,true)}
                              className="btn btn-primary"
                              type="button"
                            >
                              Add Mentor
                            </button>
                          </td>
                          
                          <td>
                          <Mentor fillColor={'white'}/>
                          </td>
                        </>
                      ) : null}

                      
                      


                      <td>
                        {candidateRating?.response?.ratingNumber ? (
                          <CandidateRating
                            ratingValue={
                              candidateRating?.response?.ratingNumber
                            }
                          />
                        ) : (
                          createStar(
                            parseFloat(
                              candidateRating?.response?.ratingNumber
                            ).toFixed(2)
                          )
                        )}
                      </td>
                      <td>
                        {candidateRating && (
                          <span>
                            {candidateRating?.response?.lastRatingDateToDisplay}
                          </span>
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            </div>
          </div>
        </div>
    </>
  );
};

export default StatusTable;
